const SERVICE = "auth";

const login = async (api, body) =>
  api
    .setMethod()
    .post()
    .setService(SERVICE)
    .setBody(body)
    .process("/login/doc");

module.exports = {
  login,
};
